<template>
    <el-dialog title="编辑成绩" :visible.sync="dialogVisible" append-to-body>

        <el-form ref="form" :model="form" :rules="rules" label-width="150px">
            <el-form-item label="成绩" prop="achievement">
                <el-input v-model="form.achievement"></el-input>
            </el-form-item>

            <el-form-item label="排名" prop="ranking">
                <el-input v-model="form.ranking"></el-input>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import { setActRanking } from '@/api/huodongguanliChengjiguanli'

    export default {
        name: 'index',
        data() {
            return {
                dialogVisible: false,
                form: {
                    token: sessionStorage.getItem("token"),
                    id: '',
                    achievement: '', // 成绩
                    ranking: '', // 排名
                },
                rules: {
                    // achievement: { required: true, message: '请输入', trigger: 'blur' },
                    // ranking: { required: true, message: '请输入', trigger: 'blur' },
                },
            }
        },
        created() {},
        methods: {
            handleOpenDialog(row) {
                this.form.id = row.id;
                this.form.achievement = '';
                this.form.ranking = row.ranking;
                this.dialogVisible = true;
            },
            handleCloseDialog() {
                this.dialogVisible = false;
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        setActRanking(this.form).then(({ data: res }) => {
                            this.$message.success('成功');
                            this.$emit('submit');
                            this.handleCloseDialog();
                        })
                    }
                });
            },
        }
    }
</script>

<style lang="less" scope>
</style>